<template lang='pug'>
  i.svg-icon.svg-icon-guild
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M61.279,48.537l-8.73,17.43c-0.694,1.385-2.379,1.952-3.761,1.261 c-0.583-0.29-1.049-0.771-1.312-1.363l-9.967-22.153l-5.265,12.575H15.743l32.005,32.712c1.198,1.246,3.175,1.284,4.42,0.091 c0.031-0.031,0.064-0.062,0.091-0.091l32.03-32.712H65.148L61.279,48.537z M88.202,18.729l-0.443-0.435 C78.894,9.22,64.348,9.054,55.268,17.92c-0.127,0.124-0.247,0.247-0.375,0.375l-4.876,5.013l-4.895-4.996 c-8.845-9.076-23.373-9.263-32.447-0.418c-0.145,0.137-0.282,0.277-0.418,0.418l-0.439,0.435 c-8.449,8.791-8.999,22.508-1.279,31.941h17.976l6.283-15.136c0.602-1.434,2.252-2.107,3.684-1.51 c0.653,0.277,1.182,0.793,1.475,1.44l10.206,22.701l8.593-17.176c0.691-1.386,2.38-1.948,3.761-1.257 c0.546,0.272,0.989,0.711,1.253,1.257l4.844,9.68h20.854c7.716-9.433,7.17-23.15-1.28-31.941L88.202,18.729z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#E95866',
    },
  },

}
</script>